<wbo-edit-page #editPage [title]="model.data.receiptNo" [exitRoute]="overrideSearchRoute" [disableAction]="true" [shouldDiscardChanges]="true">
    <wbo-entity-actions>
        <ng-container *ngIf="showActions">
            <wbo-entity-action (click)="voidSale()" *ngIf="!saleVoided" [title]="'wbo.sales-journal.edit.actions.voidSale'"></wbo-entity-action>
            <wbo-entity-action (click)="voidSurcharge()" *ngIf="hasSurcharge" [title]="'wbo.sales-journal.edit.actions.voidSurcharge'"></wbo-entity-action>
            <wbo-entity-action (click)="voidDiscount()" *ngIf="hasDiscount" [title]="'wbo.sales-journal.edit.actions.voidDiscount'"></wbo-entity-action>
            <wbo-entity-action (click)="voidCashout()" *ngIf="hasCashout" [title]="'wbo.sales-journal.edit.actions.voidCashout'"></wbo-entity-action>
            <wbo-entity-action (click)="voidTip()" *ngIf="hasTip" [title]="'wbo.sales-journal.edit.actions.voidTip'"></wbo-entity-action>
        </ng-container>
        <wbo-entity-action (click)="generateReceipt()" [title]="'wbo.sales-journal.edit.actions.invoice'"></wbo-entity-action>
    </wbo-entity-actions>
    <fui-formation-group class="basic-group no-header">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row *ngIf="saleVoided">
                <fui-two-columns>
                    <fui-column>
                        <fui-inline-information [title]="'wbo.common.info.information'"
                                                [message]="'wbo.sales-journal.edit.message.saleVoided'"></fui-inline-information>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row *ngIf="model.data.isSaleOnOpenFloat">
                <fui-two-columns>
                    <fui-column>
                        <fui-inline-information [title]="'wbo.common.info.information'"
                                                [message]="'wbo.sales-journal.edit.message.cannotVoidOpenFloat'"></fui-inline-information>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-four-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="receiptNo" [value]="model.data.receiptNo" [readonly]="true"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control label="wbo.sales-journal.edit.field.saleDate.label" placeholder="wbo.sales-journal.edit.field.saleDate.placeholder"
                                               [value]="model.data.saleDate | wbo_date_time: 'dd/MM/yyyy HH:mm:ss'" [readonly]="true"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="saleType" [value]="model.data.saleType" [readonly]="true"></wbo-text-edit-control>
                    </fui-column>
                </fui-four-columns>
            </fui-row>
            <fui-row>
                <fui-four-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="identifier" [value]="model.data.identifier" [readonly]="true"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="terminalName" [value]="model.data.terminalName" [readonly]="true"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column *ngIf="model.data.tableNo || model.data.orderName !== model.data.identifier">
                        <wbo-text-edit-control *ngIf="model.data.tableNo"
                                               label="wbo.sales-journal.edit.field.tableNo.label" placeholder="wbo.sales-journal.edit.field.tableNo.placeholder"
                                               [value]="model.data.tableNo" [readonly]="true"></wbo-text-edit-control>
                        <wbo-text-edit-control *ngIf="!model.data.tableNo && model.data.orderName !== model.data.identifier"
                                               formControlName="orderName" [value]="model.data.orderName" [readonly]="true"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <ng-container *ngIf="model.data.accrual.recMember.name && (Plugin.LOYALTY | booleanConfig)" formGroupName="accrual">
                            <ng-container formGroupName="recMember">
                                <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.accrual.recMember.name" [readonly]="true"></wbo-text-edit-control>
                            </ng-container>
                        </ng-container>
                        <wbo-text-edit-control *ngIf="!(model.data.accrual.recMember.name && (Plugin.LOYALTY | booleanConfig))"
                                               label="wbo.sales-journal.edit.field.customerName.label" placeholder="wbo.sales-journal.edit.field.customerName.placeholder"
                                               [value]="model.data.customerName" [readonly]="true"></wbo-text-edit-control>
                    </fui-column>
                </fui-four-columns>
            </fui-row>
            <fui-row>
                <fui-four-columns>
                    <fui-column>
                        <wbo-text-edit-control label="wbo.sales-journal.edit.field.recUser.name.label" placeholder="wbo.sales-journal.edit.field.recUser.name.placeholder"
                                               [value]="model.data.recUser.name" [readonly]="true"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="customerRefNo" [value]="model.data.customerRefNo" [readonly]="true"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column *ngIf="model.data.integratedDeliveryId">
                        <wbo-text-edit-control formControlName="integratedDeliveryId" [(ngModel)]="model.data.integratedDeliveryId" [readonly]="true"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column *ngIf="model.data.integratedDeliveryTrackingUrl">
                        <fui-local-button [title]="'wbo.sales-journal.edit.button.trackIntegratedDelivery'"
                                          (click)="openIntegratedDeliveryTrackingLink()"></fui-local-button>
                    </fui-column>
                </fui-four-columns>
            </fui-row>
            <fui-row>
                <fui-four-columns>
                    <fui-column>
                        <wbo-text-edit-control label="wbo.sales-journal.edit.field.discountReason.reasonComment.label"
                                               placeholder="wbo.sales-journal.edit.field.discountReason.reasonComment.placeholder"
                                               [value]="model.data.discountReason.description" [readonly]="true"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control label="wbo.sales-journal.edit.field.refundReason.reasonComment.label"
                                               placeholder="wbo.sales-journal.edit.field.refundReason.reasonComment.placeholder"
                                               [value]="model.data.refundReason.description" [readonly]="true"></wbo-text-edit-control>
                    </fui-column>
                </fui-four-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
    <fui-formation-group [title]="'wbo.sales-journal.edit.formation.saleLines'">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-column>
                    <wbo-edit-grid [data]="model.data.saleLines" [editable]="false" [removable]="false" [entityPath]="'saleLines'">
                        <wbo-text-column field="sellableName"></wbo-text-column>
                        <wbo-text-column field="type"></wbo-text-column>
                        <wbo-info-text-column field="discountReason.reasonCode.code" fieldInfo="discountReason.reasonComment" [width]="200"></wbo-info-text-column>
                        <wbo-currency-column field="unitPrice"></wbo-currency-column>
                        <wbo-numeric-column field="qty"></wbo-numeric-column>
                        <wbo-currency-column field="extrasPrice"></wbo-currency-column>
                        <wbo-currency-column field="discAmt"></wbo-currency-column>
                        <wbo-currency-column field="costEx"></wbo-currency-column>
                        <wbo-currency-column field="subTotalEx"></wbo-currency-column>
                        <wbo-currency-column field="marginEx"></wbo-currency-column>
                        <wbo-percentage-column field="marginPercentEx"></wbo-percentage-column>
                        <wbo-currency-column field="totalTax"></wbo-currency-column>
                        <wbo-currency-column field="subTotal"></wbo-currency-column>
                        <wbo-numeric-column field="refundedQty"></wbo-numeric-column>
                    </wbo-edit-grid>
                </fui-column>
            </fui-row>
            <fui-row>
                <fui-four-columns>
                    <fui-column>
                    </fui-column>
                    <fui-column>
                        <wbo-currency-edit-control label="wbo.sales-journal.edit.field.saleLineDiscounts.label"
                                                   placeholder="wbo.sales-journal.edit.field.saleLineDiscounts.placeholder"
                                                   [value]="model.data.saleLineDiscounts" [readonly]="true"></wbo-currency-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-currency-edit-control label="wbo.sales-journal.edit.field.saleLineVoidTotal.label"
                                                   placeholder="wbo.sales-journal.edit.field.saleLineVoidTotal.placeholder"
                                                   [value]="model.data.saleLineVoidTotal" [readonly]="true"></wbo-currency-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-currency-edit-control label="wbo.sales-journal.edit.field.saleLineTotal.label" placeholder="wbo.sales-journal.edit.field.saleLineTotal.placeholder"
                                                   [value]="model.data.saleLineTotal" [readonly]="true"></wbo-currency-edit-control>
                    </fui-column>
                </fui-four-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
    <fui-formation-group [title]="'wbo.sales-journal.edit.formation.saleTotals'">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-four-columns>
                    <fui-column>
                        <wbo-currency-edit-control
                                                   label="wbo.sales-journal.edit.field.totalCostEx.label" placeholder="wbo.sales-journal.edit.field.totalCostEx.placeholder"
                                                   [value]="model.data.totalCostEx" [readonly]="true"></wbo-currency-edit-control>
                        <wbo-numeric-edit-control
                                                  label="wbo.sales-journal.edit.field.marginExPerc.label" placeholder="wbo.sales-journal.edit.field.marginExPerc.placeholder"
                                                  [value]="model.data.marginExPerc" [readonly]="true"></wbo-numeric-edit-control>
                        <wbo-currency-edit-control
                                                   label="wbo.sales-journal.edit.field.marginEx.label" placeholder="wbo.sales-journal.edit.field.marginEx.placeholder"
                                                   [value]="model.data.marginEx" [readonly]="true"></wbo-currency-edit-control>
                    </fui-column>
                    <fui-column>
                        <ng-container *ngIf="model.data.accrual.recMember.name && (Plugin.LOYALTY | booleanConfig)" formGroupName="accrual">
                            <wbo-numeric-edit-control formControlName="pointsAccrued" [(ngModel)]="model.data.accrual.pointsAccrued" [readonly]="true"></wbo-numeric-edit-control>
                        </ng-container>
                    </fui-column>
                    <fui-column>
                        <ng-container formGroupName="saleDiscount">
                            <wbo-currency-edit-control formControlName="dollarAmount" [value]="model.data.saleDiscount.dollarAmount" [readonly]="true"></wbo-currency-edit-control>
                        </ng-container>
                        <ng-container formGroupName="surcharge">
                            <wbo-currency-edit-control formControlName="dollarAmount" [value]="model.data.surcharge.dollarAmount" [readonly]="true"></wbo-currency-edit-control>
                        </ng-container>
                        <wbo-currency-edit-control formControlName="rounding" [value]="model.data.rounding" [readonly]="true"></wbo-currency-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-currency-edit-control label="wbo.sales-journal.edit.field.saleTotalEx.label" placeholder="wbo.sales-journal.edit.field.saleTotalEx.placeholder"
                                                   [value]="model.data.saleTotalEx" [readonly]="true"></wbo-currency-edit-control>
                        <wbo-currency-edit-control formControlName="totalSalesTax" [value]="model.data.totalSalesTax" [readonly]="true"></wbo-currency-edit-control>
                        <wbo-currency-edit-control label="wbo.sales-journal.edit.field.saleTotal.label" placeholder="wbo.sales-journal.edit.field.saleTotal.placeholder"
                                                   [value]="model.data.saleTotalPlusRounding" [readonly]="true"></wbo-currency-edit-control>
                    </fui-column>
                </fui-four-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
    <fui-formation-group [title]="'wbo.sales-journal.edit.formation.payments'">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-column>
                    <wbo-edit-grid [data]="model.data.payments" [editable]="false" [removable]="false" [entityPath]="'payments'">
                        <wbo-text-column field="details"></wbo-text-column>
                        <wbo-text-column field="paymentType"></wbo-text-column>
                        <wbo-text-column field="reference"></wbo-text-column>
                        <wbo-info-text-column field="reason.reasonCode.code" fieldInfo="reason.reasonComment" [width]="200"></wbo-info-text-column>
                        <wbo-text-column field="paymentAccountMetaData.accountName"></wbo-text-column>
                        <wbo-currency-column field="cashout"></wbo-currency-column>
                        <wbo-currency-column field="tip"></wbo-currency-column>
                        <wbo-currency-column field="change"></wbo-currency-column>
                        <wbo-currency-column field="amount"></wbo-currency-column>
                    </wbo-edit-grid>
                </fui-column>
            </fui-row>
            <fui-row>
                <fui-four-columns>
                    <fui-column>
                    </fui-column>
                    <fui-column>
                    </fui-column>
                    <fui-column>
                        <wbo-currency-edit-control label="wbo.sales-journal.edit.field.paymentVoidTotal.label"
                                                   placeholder="wbo.sales-journal.edit.field.paymentVoidTotal.placeholder"
                                                   [value]="model.data.paymentVoidTotal" [readonly]="true"></wbo-currency-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-currency-edit-control label="wbo.sales-journal.edit.field.paymentTotal.label" placeholder="wbo.sales-journal.edit.field.paymentTotal.placeholder"
                                                   [value]="model.data.paymentTotal" [readonly]="true"></wbo-currency-edit-control>
                    </fui-column>
                </fui-four-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-edit-page>
